import React from "react";
import { Link } from "react-router-dom";
import { AlertTriangle, CreditCard } from "lucide-react";
import { usePaywall } from "@/context/PaywallContext";

/**
 * Red/amber banner shown INSIDE the admin layout whenever the paywall is in
 * grace or suspended state. Admin-only; invisible to the public site.
 */
export default function PaywallBanner() {
  const { status, data } = usePaywall();
  if (!data) return null;
  if (status === "active") return null;

  const suspended = status === "suspended";
  const styles = suspended
    ? "bg-red-600 text-white"
    : "bg-amber-500 text-[#0d2040]";
  const msg = suspended
    ? "Service suspended — pay now to reactivate the site."
    : `Grace period: ${data.grace_days_left} day${data.grace_days_left === 1 ? "" : "s"} remaining. Please pay to avoid service suspension.`;

  return (
    <div
      className={`${styles} px-4 py-2.5 flex items-center justify-between gap-3 text-sm`}
      data-testid="paywall-banner"
    >
      <div className="flex items-center gap-2 min-w-0">
        <AlertTriangle size={16} className="shrink-0" />
        <span className="truncate font-semibold">{msg}</span>
      </div>
      <Link
        to="/admin/billing"
        className="shrink-0 bg-white/15 hover:bg-white/25 px-3 py-1.5 text-[0.65rem] uppercase tracking-widest font-bold flex items-center gap-1.5"
        data-testid="paywall-banner-cta"
      >
        <CreditCard size={12} /> Pay now
      </Link>
    </div>
  );
}
